/**
 * 入金関連のAPIエンドポイント
 */

import apiClient from '../client';
import type { Deposit, DepositCreate } from '../../../types';

export const depositApi = {
  /**
   * 入金履歴取得
   * @param customerId - 顧客ID（オプション）
   * @param storeId - 店舗ID（オプション）
   */
  getDeposits: async (customerId?: number, storeId?: number): Promise<Deposit[]> => {
    const params = new URLSearchParams();

    if (customerId !== undefined) {
      params.append('customer_id', customerId.toString());
    }
    if (storeId !== undefined) {
      params.append('store_id', storeId.toString());
    }

    const queryString = params.toString();
    return apiClient.get<Deposit[]>(`/deposits${queryString ? `?${queryString}` : ''}`);
  },

  /**
   * 入金登録
   */
  createDeposit: async (depositData: DepositCreate): Promise<Deposit> => {
    return apiClient.post<Deposit>('/deposits', depositData);
  }
};
